export default __webpack_public_path__ + "static/media/0xe20f7d1f0ec39c4d5db01f53554f2ef54c71f613.a6058fe4.svg";